import { render } from "./ContentTagFilterBar.vue?vue&type=template&id=3c7e063c&scoped=true"
import script from "./ContentTagFilterBar.vue?vue&type=script&lang=js"
export * from "./ContentTagFilterBar.vue?vue&type=script&lang=js"

import "./ContentTagFilterBar.vue?vue&type=style&index=0&id=3c7e063c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7e063c"]])

export default __exports__